import { ROUTE_PATH, ROUTE_NAME } from 'utils/constants/router';
import { DOM } from 'new-ui/functions';
import './OpenInNewTab.css';

export const OpenInNewTab = () => {
  const { t } = window;
  const $oint = DOM('.open-in-new-tab', {
    '/.oint-window': {
      '/.oint-text': {
        '/.oint-text-title': {
          innerHTML: t('oint.title'),
        },
        '/.oint-text-description': {
          innerHTML: t('oint.description'),
        },
      },
      '/.oint-button': {
        '/a.oint-text-button.button': {
          innerHTML: t('oint.button'),
          href: ROUTE_PATH[ROUTE_NAME.RESULTS],
          target: '_blank',
        },
      },
    },
  });
  document.body.appendChild($oint);
};

export const preventIframeInteraction = () => {
  if (window.self !== window.top) {
    OpenInNewTab();
  }
};
